export default {
    SET_USER_DETAILS(state, payload) {
        state.brainedUserDetails = payload
    }
}